const lazyframe = async() => {
    const { default: LazyFrame } = await import(/* webpackChunkName: "lazyframe" */ 'lazyframe');

    return LazyFrame;
}

// dynamically import lazyframe
let lazyframes;

if (!lazyframes) {
    lazyframe().then(lazyframe => {
        // Passing a nodelist
        let elements = document.querySelectorAll(".lazyframe");
        lazyframes = lazyframe(elements, {
            debounce: 300,
            lazyload: true,
            autoplay: true,
        });
        // return instance
        return lazyframes;
    })
    .catch((error) => {
        console.log('Unable to load LazyFrame module');
    });
}